export default __webpack_public_path__ + "static/Office_image_2-d957b251b273c05b34f8ba12320d4a4f.png";